import { Component, OnInit, Inject } from '@angular/core';
import { Common, _, core } from '@icc/shared/helpers';
import { ConfigurationsService, DrawService, PageComponent } from '@icc/configurator/shared';
import { APP_CONFIG, AppConfigFactory, EventBusService, TranslateService } from '@icc/shared';
import { ProfilesModalService } from '../profiles/profiles-modal.service';
import { ActiveSash, WindowActiveConfiguration } from '@icc/window-door/types';
import { HandlesService } from '../modules/handles/handles.service';

@Component({
    selector: 'icc-edit-handles-page',
    templateUrl: './edit-handles-page.component.html',
    styleUrls: ['./edit-handles-page.component.scss'],
    standalone: false
})
export class EditHandlesPageComponent extends PageComponent implements OnInit {
    title = this.config().IccConfig.Configurators.editHandlePageTitleDefault  ? _('WINDOW|Klamka') : _('WINDOW|Zmiana wysokości klamki');
    fullscreen = true;

    drawOptions: any = null;
    drawButtons = {
        fullscreen: false,
        moveShift: true,
        alignments: true,
        dimensions: false,
        extensions: true,
        mullions: true,
        profiles: false,
        sashes: true,

        toggle: (
            type:
                | 'alignments'
                | 'dimensions'
                | 'extensions'
                | 'fullscreen'
                | 'mullions'
                | 'profiles'
                | 'sashes'
        ) => {
            if (type && typeof this.drawButtons[type] !== 'undefined') {
                this.drawButtons[type] = !this.drawButtons[type];
            }

            this.drawButtons.update();
        },

        update: () => {
            const conf = this.configurationsService.conf.Current;
            if (conf) {
                this.drawOptions = Object.assign({}, this.drawService.options, {
                    sashFrame: {
                        buttons: [
                            {
                                condition: (response: any) =>
                                    [
                                        'F',
                                        'FF',
                                        'OFF',
                                        'DS',
                                        'DSC',
                                        'ODS',
                                        'DRP',
                                        'DOP',
                                        'FD',
                                        'FDO',
                                    ].indexOf(response.sash.type.type) === -1,
                                innerHtml: `<img src="/application/dist/web/img/icons/handler.png">`,
                                title: this.translateService.instant('WINDOW|Wybierz klamkę'),
                                onClick: (response: any) => {
                                    const sash = core.fIdO(
                                        this.configurationsService.conf.Current.Sashes,
                                        response.sash.id
                                    );
                                    this.openModalHandle(sash, 'innerLever');
                                },
                            },
                        ],
                    },
                    onInterfaceClick: () => {},
                });
                this.drawOptions.base.side = 'inner';
            }

            this.eventBusService.post({
                key: 'icc-redraw',
                value: null,
            });
        },
    };

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private eventBusService: EventBusService,
        private configurationsService: ConfigurationsService<'window'>,
        public drawService: DrawService,
        private profilesModalService: ProfilesModalService,
        private translateService: TranslateService,
        private handlesService: HandlesService
    ) {
        super();
    }

    ngOnInit() {
        this.drawButtons.update();
    }

    openModalHandle(sash: 'window' | ActiveSash | undefined, place: string) {
        if (
            place === 'innerLever'
            && (sash === 'window'
                || (sash && sash.type && sash.type.type !== 'DRA' && sash.type.type !== 'DOA'))
        ) {
            this.handlesService.openModalHandle(sash, place, 'InnerLever');
            if (this.config().IccConfig.Configurators.tutorialAvailable) {
                this.eventBusService.post({
                    key: 'tutorialSteps',
                    value: 'modalHandleSash',
                });
            }
        } else {
            this.handlesService.openModalHandle(
                sash,
                place,
                this.configurationsService.conf.Current.HandleType
            );
            if (this.config().IccConfig.Configurators.tutorialAvailable) {
                this.eventBusService.post({
                    key: 'tutorialSteps',
                    value: 'modalHandle',
                });
            }
        }
    }
}
